import { c as _c } from "react/compiler-runtime";
import { ReactQueryWrapperContext } from "@/components/react-query-wrapper/ReactQueryWrapper";
import { useContext, useEffect } from "react";
import { commonApiPostWithoutBodyAndResponse } from "@/services/api/common-api";
interface UseWaveDropsNotificationReadParams {
  readonly waveId: string;
  readonly removeWaveDeliveredNotifications: (waveId: string) => Promise<unknown> | void;
}
export const useWaveDropsNotificationRead = t0 => {
  const $ = _c(5);
  const {
    waveId,
    removeWaveDeliveredNotifications
  } = t0;
  const {
    invalidateNotifications
  } = useContext(ReactQueryWrapperContext);
  let t1;
  let t2;
  if ($[0] !== invalidateNotifications || $[1] !== removeWaveDeliveredNotifications || $[2] !== waveId) {
    t1 = () => {
      const syncReadState = async () => {
        ;
        try {
          await Promise.resolve(removeWaveDeliveredNotifications(waveId));
        } catch (t3) {
          const error = t3;
          console.error("Failed to remove wave delivered notifications:", error);
        }
        commonApiPostWithoutBodyAndResponse({
          endpoint: `notifications/wave/${waveId}/read`
        }).then(() => {
          invalidateNotifications();
        }).catch(_temp);
      };
      syncReadState();
    };
    t2 = [waveId, removeWaveDeliveredNotifications, invalidateNotifications];
    $[0] = invalidateNotifications;
    $[1] = removeWaveDeliveredNotifications;
    $[2] = waveId;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
};
function _temp(error_0) {
  return console.error("Failed to mark feed as read:", error_0);
}